<template>
	<div class="lineTime"><div class="lineTime_total">{{ timeLineTotal }}</div></div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "LineTime",
	computed: mapGetters([ 'timeLineTotal' ])
};
</script>

<style scoped lang="scss">

</style>
